// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JobTableView-base__ar51_{position:relative;display:flex;flex-direction:column;height:var(--size-full);overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "JobTableView-base__ar51_"
};
export default ___CSS_LOADER_EXPORT___;
